import React from 'react';
import { Box, TextField, FormControlLabel, Checkbox, Switch, Typography } from '@mui/material';
import { WA_GREEN } from '../whatsappPreview';
import { FlowComponent } from '../../../../flow-core/FlowComponent';
import { OptInCore } from '../../../../flow-core/components/OptInCore';

export const OptInComponent = new FlowComponent({
  ...OptInCore,
  renderPreview(properties) {
    // WhatsApp puts "(optional)" BEFORE an opt-in's label, and offers its link as "Read more".
    return (
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mt: 2, opacity: properties.visible === false ? 0.5 : 1 }}>
        <Checkbox disabled sx={{ p: 0, mt: '1px' }} />
        <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>
          {properties.required ? '' : '(optional) '}
          {properties.label || 'I agree to the terms'}
          {properties['on-click-action'] && (
            <Box component="span" sx={{ color: WA_GREEN, ml: 0.5 }}>Read more</Box>
          )}
        </Typography>
      </Box>
    );
  },
  renderPropertyEditor(properties, onChange) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          fullWidth
          label="Field Name"
          value={properties.name || ''}
          onChange={(e) => onChange('name', e.target.value)}
          required
          size="small"
          helperText="Used to identify this field in the form data"
        />

        <TextField
          fullWidth
          label="Label"
          value={properties.label || ''}
          onChange={(e) => onChange('label', e.target.value)}
          required
          size="small"
          multiline
          rows={2}
          helperText="Text shown next to the checkbox"
        />

        <FormControlLabel
          control={
            <Switch
              checked={properties.required || false}
              onChange={(e) => onChange('required', e.target.checked)}
            />
          }
          label="Required"
        />
      </Box>
    );
  },
});
